/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import {useFormik} from 'formik'
import makeAnimated from 'react-select/animated'
import * as Yup from 'yup'
import axios from 'axios'
import Swal from 'sweetalert2'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../styles/styles'
import {Input3} from '../../../../../../components/Forms/Input'
import {
  IndemnityArea,
  IndemnityAreaInitValues as initialValues,
} from '../indemnityItems-list/core/_models'
import {useQueryClient} from 'react-query'

export interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

type Props = {
  show: boolean
  handleClose: () => void
  id: string
  property_uuid: string
}
const propertiesSchema = Yup.object().shape({})
const API_URL = process.env.REACT_APP_API_URL || 'api'

const ModalAddIdemminityArea: React.FC<Props> = ({show, handleClose, id, property_uuid}) => {
  const intl = useIntl()
  const queryClient = useQueryClient()
  const animatedComponents = makeAnimated()
  const [loading, setLoading] = useState(false)
  const [isCheckedSingleServitude, setIsCheckedSingleServitude] = useState(false)
  const [isCheckedAnnualServitude, setIsCheckedAnnualServitude] = useState(false)
  const [isCheckedDirectDamage, setIsCheckedDirectDamage] = useState(false)
  const [isCheckedBusinessInterruption, setIsCheckedBusinessInterruption] = useState(false)

  const [valuesSingleServitude, setValuesSingleServitude] = useState([])
  const [valuesAnualServitude, setValuesAnualServitude] = useState([])
  const [valuesDirectDamage, setValuesDirectDamage] = useState([])
  const [quantityValue, setquantityValue] = useState('')

  const handleOnChangeSingleServitude = () => {
    setIsCheckedSingleServitude(!isCheckedSingleServitude)
  }
  const handleOnChangeAnnualServitude = () => {
    setIsCheckedAnnualServitude(!isCheckedAnnualServitude)
  }
  const handleOnChangeDirectDamage = () => {
    setIsCheckedDirectDamage(!isCheckedDirectDamage)
  }
  const handleOnChangeBusinessInterruption = () => {
    setIsCheckedBusinessInterruption(!isCheckedBusinessInterruption)
  }

  const loadOptionsIndemnityItems = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getOwners()

      let owners: any = []
      async function getOwners() {
        const {data} = await axios.get(
          `${API_URL}/sgt/v1/indemnity_items/select2?property_uuid=${property_uuid}`
        )

        let Response = data.results

        if (Response) {
          for (const element of Response) {
            const owner: any = {
              value: element.id,
              label: element.text,
              outgoingProfitValue: element.outgoing_profit_value,
              directDamageValue: element.direct_damage_value,
              singlePaymentValue: element.single_payment_value,
            }
            owners.push(owner)
          }
        }
      }
      callback(owners)
    }, 1000)
  }

  const handleInputChangeIndemnityItems = (event: any) => {
    let inputValue = ''
    inputValue = event.value
    formik.setFieldValue('indemnity_item_id', inputValue)
    parseFloat(event.singlePaymentValue)
    parseFloat(event.directDamageValue)
    parseFloat(event.outgoingProfitValue)
    setValuesSingleServitude(event.singlePaymentValue)
    setValuesDirectDamage(event.directDamageValue)
    setValuesAnualServitude(event.outgoingProfitValue)
    return {inputValue}
  }

  const formik = useFormik<IndemnityArea>({
    initialValues,
    validationSchema: propertiesSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        await axios.post(`${API_URL}/sgt/v1/properties/${property_uuid}/indemnity_areas`, values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'INDEMNITY_ITEM.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        queryClient.invalidateQueries('indemnity-area-list-page=1&items_per_page=10')
        handleClose()
        setIsCheckedSingleServitude(false)
        setIsCheckedAnnualServitude(false)
        setIsCheckedDirectDamage(false)
        setIsCheckedBusinessInterruption(false)
        formik.resetForm()
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'INDEMNITY_ITEM.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
        formik.resetForm()
        setIsCheckedSingleServitude(false)
        setIsCheckedAnnualServitude(false)
        setIsCheckedDirectDamage(false)
        setIsCheckedBusinessInterruption(false)
        handleClose()
      }
    },
  })

  const soma = (x: any, y: any) => {
    let result = x * y
    const formCurrency = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    }).format(result)
    return formCurrency
  }

  return (
    <Modal
      id={id}
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-600px h-auto'
      show={show}
      onHide={handleClose}
    >
      <div className='container-xxl p-5'>
        <div className='modal-header py-2 d-flex justify-align-content-between border-0'>
          {/* begin::Close */}
          <span className='fw-bold fs-4 '>
            {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.TITLE_HEADER'})}
          </span>
          <div className='btn btn-icon btn-sm btn-light-primary' onClick={handleClose}>
            <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9'>
              <div className='col-lg-12'>
                <div className='row'>
                  {/* INICIO NOME PROPRIEDADE */}

                  <input
                    type='text'
                    className='d-none form-control-lg form-control-solid mb-3 mb-lg-0'
                    // placeholder={intl.formatMessage({id: 'COMMON.INPUT_IDENTIFIER'})}
                  />
                  {formik.touched.property_uuid && formik.errors.property_uuid && (
                    <div className='fv-plugins-message-container text-danger'>
                      <div className='fv-help-block'>{formik.errors.property_uuid}</div>
                    </div>
                  )}

                  <div className='row mb-3'>
                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                      {intl.formatMessage({id: 'INDEMNITY_ITEM.ADD_BUTTON'})}
                    </label>

                    <div className='col-lg-12'>
                      <div className='row'>
                        <div className='col-lg-12 fv-row'>
                          <AsyncSelect
                            className='form-control form-control-lg form-control-solid p-1 ps-3'
                            styles={colourStyles}
                            components={animatedComponents}
                            cacheOptions
                            loadOptions={loadOptionsIndemnityItems}
                            filterOption={(option, inputValue) =>
                              option.label
                                ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                                : false
                            }
                            defaultOptions
                            onChange={handleInputChangeIndemnityItems}
                            placeholder={intl.formatMessage({
                              id: 'INDEMNITY_ITEM.TITLE',
                            })}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                              },
                            })}
                          />
                        </div>
                      </div>
                    </div>
                    {/* FIM NOME PROPRIEDADE */}

                    {/* INICIO NOME PORCENTAGEM */}
                    <div className='row mb-5'>
                      <Input3
                        title={intl.formatMessage({id: 'COMMON.YEAR'})}
                        placeholder={intl.formatMessage({id: 'COMMON.YEAR'})}
                        {...formik.getFieldProps('years')}
                      />
                      <Input3
                        title={intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.QUANTITY'})}
                        placeholder={intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.QUANTITY'})}
                        // {...formik.getFieldProps('quantity')}
                        onChange={(e: any) => {
                          formik.setFieldValue('quantity', e.target.value)
                          setquantityValue(e.target.value)
                        }}
                      />

                      {/* FIM NOME PORCENTAGEM */}
                    </div>

                    <div className='row mb-5'>
                      {/* inicio servidão anual */}
                      <div className='col-lg-6 mb-5'>
                        <label className='form-label fs-6 fw-bold d-flex mb-3 required'>
                          {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.ANNUAL_SERVITUDE'})}
                        </label>
                        <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
                          <label className='form-check-label'>
                            {intl.formatMessage({id: 'COMMON.NO'})}
                            &nbsp;
                          </label>
                          <input
                            className='form-check-input w-45px h-30px'
                            type='checkbox'
                            id='allowmarketing'
                            {...formik.getFieldProps('annual_servitude')}
                            onClick={handleOnChangeAnnualServitude}
                          />
                          <label className='form-check-label'>
                            {intl.formatMessage({id: 'COMMON.YES'})}
                          </label>
                          <div
                            className={'flex-row-fluid ' + (!isCheckedAnnualServitude && 'd-none')}
                          >
                            <p className='text-success fs-4 my-2 px-5'>
                              {soma(quantityValue, valuesAnualServitude)}
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* Fim servidão anual */}

                      {/* inicio servidão unica */}

                      <div className='col-lg-6 mb-5'>
                        <label className='form-label fs-6 fw-bold d-flex mb-3 required'>
                          {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.SINGLE_SERVITUDE'})}
                        </label>
                        <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
                          <label className='form-check-label'>
                            {intl.formatMessage({id: 'COMMON.NO'})}
                            &nbsp;
                          </label>
                          <input
                            className='form-check-input w-45px h-30px'
                            type='checkbox'
                            id='allowmarketing'
                            {...formik.getFieldProps('single_servitude')}
                            onClick={handleOnChangeSingleServitude}
                          />
                          <label className='form-check-label'>
                            {intl.formatMessage({id: 'COMMON.YES'})}
                          </label>
                          <div
                            className={'flex-row-fluid ' + (!isCheckedSingleServitude && 'd-none')}
                          >
                            <p className='text-success fs-4 my-2 px-5'>
                              {soma(quantityValue, valuesSingleServitude)}
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* Fim servidão unica */}
                    </div>

                    <div className='row d-flex justify-content-between mb-5'>
                      <div className='col-lg-6 '>
                        <label className='form-label fs-6 fw-bold d-flex mb-3 required'>
                          {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.BUSINESS_INTERRUPTION'})}
                        </label>
                        <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
                          <label className='form-check-label'>
                            {intl.formatMessage({id: 'COMMON.NO'})}
                            &nbsp;
                          </label>
                          <input
                            className='form-check-input w-45px h-30px'
                            type='checkbox'
                            id='allowmarketing'
                            {...formik.getFieldProps('business_interruption')}
                            onClick={handleOnChangeBusinessInterruption}
                            // defaultChecked={data.allowMarketing}
                            // onChange={() => {
                            //   updateData({allowMarketing: !data.allowMarketing})
                            // }}
                          />
                          <label className='form-check-label'>
                            {intl.formatMessage({id: 'COMMON.YES'})}
                          </label>
                          <div
                            className={
                              'flex-row-fluid ' + (!isCheckedBusinessInterruption && 'd-none')
                            }
                          >
                            <p className='text-success fs-4 my-2 px-3'>
                              {soma(quantityValue, valuesAnualServitude)}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className='col-lg-6 '>
                        <label className='form-label fs-6 fw-bold d-flex mb-3 required'>
                          {intl.formatMessage({id: 'INDEMNITY_ITEM_AREA.DIRECT_DAMAGE'})}
                        </label>
                        <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
                          <label className='form-check-label'>
                            {intl.formatMessage({id: 'COMMON.NO'})}
                            &nbsp;
                          </label>
                          <input
                            className='form-check-input w-45px h-30px'
                            type='checkbox'
                            id='allowmarketing'
                            {...formik.getFieldProps('direct_damage')}
                            onClick={handleOnChangeDirectDamage}
                            // defaultChecked={data.allowMarketing}
                            // onChange={() => {
                            //   updateData({allowMarketing: !data.allowMarketing})
                            // }}
                          />
                          <label className='form-check-label'>
                            {intl.formatMessage({id: 'COMMON.YES'})}
                          </label>
                          <div className={'flex-row-fluid ' + (!isCheckedDirectDamage && 'd-none')}>
                            <p className='text-success fs-4 my-2 px-5'>
                              {soma(quantityValue, valuesDirectDamage)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Submit */}
                    <div className='d-flex justify-content-end py-6'>
                      <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                        {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                        {loading && (
                          <span className='indicator-progress' style={{display: 'block'}}>
                            {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </div>
                    {/* ----------------------------------------------------------------------------------- */}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddIdemminityArea}
